/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3ParticipationRatesFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3ParticipationRatesFormat = ClosedEnum<
  typeof GetApiV3ParticipationRatesFormat
>;

export const GetApiV3ParticipationRatesIncludeTopic = {
  TopicGovernance: "TOPIC_GOVERNANCE",
} as const;
export type GetApiV3ParticipationRatesIncludeTopic = ClosedEnum<
  typeof GetApiV3ParticipationRatesIncludeTopic
>;

export type GetApiV3ParticipationRatesRequest = {
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3ParticipationRatesFormat | undefined;
  /**
   * Step value in seconds(multiple of 86400 seconds(1 day))
   */
  step?: number | null | undefined;
  includeTopic?: GetApiV3ParticipationRatesIncludeTopic | null | undefined;
};

/** @internal */
export const GetApiV3ParticipationRatesFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3ParticipationRatesFormat
> = z.nativeEnum(GetApiV3ParticipationRatesFormat);

/** @internal */
export const GetApiV3ParticipationRatesFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3ParticipationRatesFormat
> = GetApiV3ParticipationRatesFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ParticipationRatesFormat$ {
  /** @deprecated use `GetApiV3ParticipationRatesFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3ParticipationRatesFormat$inboundSchema;
  /** @deprecated use `GetApiV3ParticipationRatesFormat$outboundSchema` instead. */
  export const outboundSchema = GetApiV3ParticipationRatesFormat$outboundSchema;
}

/** @internal */
export const GetApiV3ParticipationRatesIncludeTopic$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3ParticipationRatesIncludeTopic> = z.nativeEnum(
    GetApiV3ParticipationRatesIncludeTopic,
  );

/** @internal */
export const GetApiV3ParticipationRatesIncludeTopic$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3ParticipationRatesIncludeTopic> =
    GetApiV3ParticipationRatesIncludeTopic$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ParticipationRatesIncludeTopic$ {
  /** @deprecated use `GetApiV3ParticipationRatesIncludeTopic$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ParticipationRatesIncludeTopic$inboundSchema;
  /** @deprecated use `GetApiV3ParticipationRatesIncludeTopic$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ParticipationRatesIncludeTopic$outboundSchema;
}

/** @internal */
export const GetApiV3ParticipationRatesRequest$inboundSchema: z.ZodType<
  GetApiV3ParticipationRatesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  start: z.nullable(z.number()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3ParticipationRatesFormat$inboundSchema.default("json"),
  step: z.nullable(z.number().int()).default(null),
  include_topic: z.nullable(
    GetApiV3ParticipationRatesIncludeTopic$inboundSchema,
  ).default(null),
}).transform((v) => {
  return remap$(v, {
    "include_topic": "includeTopic",
  });
});

/** @internal */
export type GetApiV3ParticipationRatesRequest$Outbound = {
  start: number | null;
  end: number | null;
  format: string;
  step: number | null;
  include_topic: string | null;
};

/** @internal */
export const GetApiV3ParticipationRatesRequest$outboundSchema: z.ZodType<
  GetApiV3ParticipationRatesRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3ParticipationRatesRequest
> = z.object({
  start: z.nullable(z.number()).default(null),
  end: z.nullable(z.number()).default(null),
  format: GetApiV3ParticipationRatesFormat$outboundSchema.default("json"),
  step: z.nullable(z.number().int()).default(null),
  includeTopic: z.nullable(
    GetApiV3ParticipationRatesIncludeTopic$outboundSchema,
  ).default(null),
}).transform((v) => {
  return remap$(v, {
    includeTopic: "include_topic",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ParticipationRatesRequest$ {
  /** @deprecated use `GetApiV3ParticipationRatesRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3ParticipationRatesRequest$inboundSchema;
  /** @deprecated use `GetApiV3ParticipationRatesRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ParticipationRatesRequest$outboundSchema;
  /** @deprecated use `GetApiV3ParticipationRatesRequest$Outbound` instead. */
  export type Outbound = GetApiV3ParticipationRatesRequest$Outbound;
}

export function getApiV3ParticipationRatesRequestToJSON(
  getApiV3ParticipationRatesRequest: GetApiV3ParticipationRatesRequest,
): string {
  return JSON.stringify(
    GetApiV3ParticipationRatesRequest$outboundSchema.parse(
      getApiV3ParticipationRatesRequest,
    ),
  );
}

export function getApiV3ParticipationRatesRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3ParticipationRatesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3ParticipationRatesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3ParticipationRatesRequest' from JSON`,
  );
}
